import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCircleChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import { useHttpClient } from '../../shared/hooks/http-hook';
import HorizontalSlider from '../components/HorizontalSlider';
import Influencers from '../components/Influencers';
import Journal from '../components/Journal';
import TrackerHeading from '../components/TrackerHeading';

function StressNMoodTracker(props) {
  const { t } = useTranslation();
  const { sendRequest } = useHttpClient();
  const [isSaved, setIsSaved] = useState(false);
  const [date, setDate] = useState(false);
  const [data, setData] = useState(null);
  const [journal, setJournal] = useState(null);
  const [currentTracker, setCurrentTracker] = useState(null);

  const stressValues = [
    { id: 1, title: `${t('T188')} (1)`, label: `${t('T188')} (1)` },
    { id: 2, title: `${t('T189')} (2)`, label: `${t('T189')} (2)` },
    { id: 3, title: `${t('T190')} (3)`, label: `${t('T190')} (3)` },
    { id: 4, title: `${t('T191')} (4)`, label: `${t('T191')} (4)` },
    { id: 5, title: `${t('T192')} (5)`, label: `${t('T192')} (5)` },
  ];

  const getData = async (date) => {
    if (date.length > 0) {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/trackers/stress/${date}`
        );
        if (response && response.tracker?._id) {
          const { tracker } = response;
          setCurrentTracker({
            id: tracker._id,
            trackerDate: tracker.tracker_date.toString().slice(0, 10),
          });
          const data = JSON.parse(tracker.data);
          setData(data);
          setJournal({
            enhancers: tracker.enhancers,
            inhibitors: tracker.inhibitors,
            journal: tracker.journal,
          });
          setIsSaved(true);
        } else {
          setCurrentTracker({
            id: '',
            trackerDate: date,
          });
          setData({
            stress_at_moment: '',
            bar_index: 16,
          });
          setJournal({
            enhancers: [],
            inhibitors: [],
            journal: '',
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    getData(date);
  }, [date]);

  const saveResponse = (location, stat) => {
    if (location === 'journal') {
      setJournal((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    } else {
      setData((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    }
  };

  const sendData = async () => {
    let method = 'POST';
    let url = `${process.env.REACT_APP_BACKEND_URL}/trackers/`;
    if (currentTracker.id !== '') {
      method = 'PUT';
      url = `${process.env.REACT_APP_BACKEND_URL}/trackers/${currentTracker.id}`;
    }
    try {
      const response = await sendRequest(
        url,
        method,
        JSON.stringify({
          trackerDate: date,
          type: 'stress',
          data,
          hidden: false,
          enhancers: journal.enhancers,
          inhibitors: journal.inhibitors,
          journal: journal.journal,
          platform: 'web',
        })
      );
      if (response) {
        setIsSaved(true);
        props.closeTrackers();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendData();
  };

  return (
    <div
      id="snm-stress"
      className="tracker-container"
      role="region"
      aria-label={`${t('T347')} ${t('tracker.region.title')}`}
    >
      <form className="tracker-form" onSubmit={handleSubmit} noValidate={false}>
        <div className="trackers-inner">
          <div className="back-to-main">
            <button
              className="back-btn"
              aria-label={t('A136')}
              title={t('A136')}
              onClick={props.handleBackToMain}
              type="button"
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} />
            </button>
          </div>
          <TrackerHeading title="T185" setDate={setDate} isSaved={isSaved} />
          <div className="trackers-body" role="group" aria-label={t('modal.tracker.details')}>
            <div className="ind-tracker" role="group" aria-labelledby="stress-tracker-slider">
              <h2 className="title" id="stress-tracker-slider">
                {t('T186')}
              </h2>
              <HorizontalSlider
                questionid="stress_at_moment"
                data={data}
                customValues={stressValues}
                saveResponse={saveResponse}
                required
                title={t('T186')}
              />
              <input
                type="hidden"
                name="stress_at_moment"
                value={data?.stress_at_moment || ''}
                required
                aria-label={t('T186')}
              />
            </div>
            <div className="ind-tracker" role="group" aria-labelledby="stress-tracker-influencers">
              <div className="tracker-content-heading">
                <h2 className="title" id="stress-tracker-influencers">
                  {t('T187')}
                </h2>
                <p className="optional-text">{t('T019')}</p>
              </div>
              <Influencers
                stress
                questionid={['enhancers', 'inhibitors']}
                data={journal}
                saveResponse={saveResponse}
                redListAriaLabel={t('trackers.influencers.stress')}
                titleId="stress-tracker-influencers"
              />
            </div>
            <div className="ind-tracker" role="group" aria-label={`${t('T347')} - ${t('T018')}`}>
              <Journal
                placeholder={t('T020')}
                questionid="journal"
                data={journal}
                saveResponse={saveResponse}
              />
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button onClick={props.closeTrackers} variant="secondary" color="dark" type="button">
            {t('T015')}
          </Button>
          <Button type="submit" icon={{ faIconDefinition: faArrowRight }} iconPosition="right">
            {t('T016')}
          </Button>
        </div>
      </form>
    </div>
  );
}
export default StressNMoodTracker;
